// NOTE: adapted from us-frontend

import * as React from 'react';

import { comp } from '../betslip/util/utils';

import styles from './styles/button.module.css';

export interface IProps {
  backgroundColor?: string;
  borderColor?: string;
  children: React.ReactNode;
  className?: string;
  color?: string;
  disabled?: boolean;
  elevation?: string;
  height?: number;
  noPadding?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  regressionTag?: string;
  shape?: string;
  style?: React.CSSProperties;
  testId?: string;
  type?: string;
  width?: number;
}

function OCButton({
  borderColor,
  children,
  className,
  disabled,
  height,
  noPadding,
  onClick,
  regressionTag,
  shape,
  style,
  testId,
  type = '',
  width
}: IProps) {
  if (shape === 'square' && !height && !width) {
    console.warn('A height and width should be provided for a square button');
  }

  const stylesObj = {
    ...style,
    borderColor,
    height,
    width
  };

  const classes = comp(
    styles.button,
    styles[type] || '',
    shape ? styles[shape] : '',
    className || '',
    noPadding ? styles.noPadding : ''
  );

  return (
    <button
      onClick={onClick}
      className={classes}
      style={stylesObj}
      data-testid={testId}
      data-regression-tag={regressionTag}
      disabled={disabled}>

			{children}
		</button>);

}

export default OCButton;